import { Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreakpointService } from '../../../../services/breakpoints';
import { ActionButtonsComponent } from '../../molecules';
import { CookieBannerFacade } from './services/cookie-banner.facade';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.scss',
  standalone: true,
  imports: [ActionButtonsComponent],
  providers: [CookieBannerFacade],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieBannerComponent {
  private readonly facade = inject(CookieBannerFacade);
  private readonly breakpointService = inject(BreakpointService);

  readonly hide = output();

  protected readonly isMobile = toSignal(
    this.breakpointService.isMatchingBreakpoint(Breakpoints.Handset),
    { initialValue: false },
  );

  protected onAcceptAllClick(): void {
    this.facade.acceptAll();
    this.hide.emit();
  }

  protected onOpenConfigurationClick(): void {
    this.facade.openConfigurationModal();
    this.hide.emit();
  }
}
